import React from "react";
import { useTranslation } from "react-i18next";

const MoreDetailsPopup = ({
  numberOfTracking,
  status,
  cart,
  onClose,
  imgCart,
  cartLink,
  cartIsPacking,
}) => {
  const { t } = useTranslation();
  const statusMessages = {
    pending: "statusPending",
    priced: "statusPriced",
    requested: "statusRequested",
    purchased: "statusPurchased",
    received: "statusReceived",
    packed: "statusPacked",
    shipped: "statusShipped",
    delivered: "statusDelivered",
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-20">
      <div className="relative w-11/12 text-black rounded-md shadow-lg bg-yellow-50 lg:w-5/12 md:w-9/12">
        {cartIsPacking ? (
          <>
            <div className="relative p-3">
              <button
                className="absolute text-black duration-300 top-3 end-3 hover:text-red-500"
                onClick={onClose}
              >
                ✕
              </button>

              <div className="my-2 space-y-2 text-sm lg:text-base">
                <p className="my-2 text-[17px] text-center md:font-bold md:text-2xl">
                  📦 <strong>{t("PackagingSuccess.title")}</strong>
                </p>

                <p className="text-center">{t("PackagingSuccess.message")}</p>
                <div className="flex flex-col items-center justify-center w-full gap-2 lg:flex-row lg:gap-4">
                  <img src={imgCart} className="flex items-center w-1/3" />
                  <div className="flex flex-col justify-between w-full h-full gap-2 lg:w-2/3 lg:gap-4">
                    <p className="">
                      - {t("PackagingSuccess.beforeWeight")}:{" "}
                      <strong>
                        {cart.totalWeight} {t("kg")}
                      </strong>
                    </p>
                    <p>
                      - {t("PackagingSuccess.afterWeight")}:{" "}
                      <strong>
                        {cart.totalWeightAfterPacking} {t("kg")}
                      </strong>
                    </p>
                    <p>
                      - {t("PackagingSuccess.savedWeight")}:{" "}
                      <strong>
                        {(
                          cart.totalWeight - cart.totalWeightAfterPacking
                        ).toFixed(2)}{" "}
                        {t("kg")}
                      </strong>
                    </p>

                    <p>✅ {t("PackagingSuccess.note")}</p>
                    <p>{t("PackagingSuccess.thanks")}</p>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="relative p-3">
              <button
                className="absolute text-black duration-300 top-3 end-3 hover:text-red-500"
                onClick={onClose}
              >
                ✕
              </button>

              <div className="my-2 space-y-2 text-sm lg:text-base">
                <p className="my-2 text-[17px] text-center md:font-bold md:text-2xl">
                  🚚 <strong>{t("TrackingInformation")}</strong>
                </p>

                <p className="text-center text-gray-600">
                  {t("TrackingInformationSubtitle")}
                </p>

                <div className="flex flex-col items-center justify-center w-full gap-2 lg:gap-4">
                  <div className="flex flex-col justify-between w-full h-full gap-2 lg:gap-4">
                    <p className="">
                      - {t("TrackingStatus")}:{" "}
                      <strong className="text-blue-600">
                        {t(`${statusMessages[status]}`)}
                      </strong>
                    </p>

                    <p>
                      - {t("TrackingLink")}:{" "}
                      {cartLink ? (
                        <a
                          href={cartLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="font-bold text-blue-600 underline hover:text-blue-800"
                        >
                          <strong>{t("link")}</strong>
                        </a>
                      ) : (
                        <strong className="text-orange-500">
                          {t("waiting")}...
                        </strong>
                      )}
                    </p>

                    <p>
                      - {t("TrackingNumber")}:{" "}
                      {numberOfTracking ? (
                        <strong className="text-black">
                          {numberOfTracking}
                        </strong>
                      ) : (
                        <strong className="text-orange-500">
                          {t("waiting")}...
                        </strong>
                      )}
                    </p>

                    <p>{t("TrackingSuccessThanks")}</p>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MoreDetailsPopup;
